const MOCKED_MESSAGES = [
  {
    id: '1',
    preview:
      'Klar luft i byerne – en mulighed for alle\nVi drømmer om byer, hvor luften er klar, og børn trygt kan lege uden bekymring for udstødningsgasser. Gør visionen til virkelighed – tag ansvar sammen med os.\nLæs hvordan vi forandrer byen\nArticel in Meta',
  },
  {
    id: '2',
    preview:
      'Børns sikkerhed i fokus: Renere byer fremtidens mål\nForestil dig en by, hvor hvert åndedrag er fri for udstødningsgasser. Det er ikke kun muligt – det er nødvendigt for vores børns sikkerhed.\nSe vores initiativer\nArticel in Meta',
  },
  {
    id: '3',
    preview:
      'Visionen om grønnere byer kan blive virkelighed\nKlar luft betyder sundhed og tryghed for børn. Sammen kan vi gøre visionen til virkelighed og skabe forandring, der varer.\nEngagér dig i kampen mod forurening\nArticel in Meta',
  },
  {
    id: '4',
    preview:
      'Klar luft: Vores fælles ansvar\nEn tryg legeplads uden udstødningsgasser – det er muligt, hvis vi handler nu.\nBliv en del af løsningen\nArticel in Meta',
  },
  {
    id: '5',
    preview:
      'Byliv uden bekymringer for børnene\nVi tror på, at klare byer uden farlige gasser skaber bedre livskvalitet for alle.\nLæs vores anbefalinger\nArticel in Meta',
  },
  {
    id: '6',
    preview:
      'Fremtidens byer: Ren luft for næste generation\nVores vision om renere byer skal beskytte børns sundhed og deres fremtid.\nTag de næste skridt med os\nArticel in Meta',
  },
  {
    id: '7',
    preview:
      'Ren luft – et valg for morgendagens børn\nNår vi prioriterer klar luft, investerer vi i børns liv og trivsel i byen.\nStøt vores sag\nArticel in Meta',
  },
  {
    id: '8',
    preview:
      'Drømmen om klare byer er tættere på end du tror\nVi står sammen om at bekæmpe udstødningsgasser og skabe trygge rammer for børn i byen.\nLæs mere om initiativet\nArticel in Meta',
  },
  {
    id: '9',
    preview:
      'Børns ret til ren luft – din indsats gør forskellen\nDet kræver fælles handling at skabe byer, hvor børn kan lege uden bekymringer.\nGør en forskel i dag\nArticel in Meta',
  },
  {
    id: '10',
    preview:
      'Samfundets ansvar: Klar luft til byens yngste\nVi har muligheden for at forandre byen, så luftforurening ikke skal bekymre vores børn.\nBliv oplyst og vær med\nArticel in Meta',
  },
];

export default MOCKED_MESSAGES;
